import EmployeeList from "./employee-list";

export default EmployeeList